/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import ObjectSelectedRows from "../SelectedBody/ObjectSelectedRows";
import { useGetAllUsersQuery } from "../../../../Redux/service/Users/Users";
import AssignDriverPopup from "./AssignDriverPopup";
import { popupcontext } from "../../../../context/Popupscontext";
import { useGetDriversByDeviceQuery } from "../../../../Redux/service/DriversTraccar/DriversTraccar";
import trans from "../../../../utils";

export default function ObjectSelectedDetails({ details, device }) {
	const { data } = useGetAllUsersQuery();
	const { setIsControlsPopup } = useContext(popupcontext);
	const [driverPopup, setDriverPopup] = useState(false);
	const { data: driverData, refetch } = useGetDriversByDeviceQuery(device?.id, {
		skip: !device?.id,
	});
	const onClick = () => {
		setDriverPopup(true);
		setIsControlsPopup(true);
	};
	useEffect(() => {
		if (driverData) refetch();
	}, [driverPopup]);
	const selectedUser = data?.find((user) => user?.id === details?.parent);
	const lang = localStorage.getItem("lang") || "en";
	return (
		<>
			<div className="object-selected-details">
				<div className="flex-center mb-2">
					<img src={`${process.env.PUBLIC_URL}/assets/Car.svg`} alt="car" />
					<div className={`${lang === "en" ? "ms-3" : "me-3"}`}>
						<div className="fs-16 fw-600 neutral-700">{details?.name}</div>
						<div className="fs-14 fw-400 neutral-500">{details?.brand}</div>
					</div>
				</div>
				<ObjectSelectedRows
					title={trans("Car Number")}
					item={details?.plateNumber}
				/>
				<ObjectSelectedRows
					title={trans("SIM Number")}
					item={details?.simNumber}
				/>
				<ObjectSelectedRows title={trans("Device Id")} item={details?.imei} />
				<ObjectSelectedRows
					title={trans("Car Activity")}
					item={details?.archived === false ? "Active" : "Archived"}
				/>

				{/*<ObjectSelectedRows
					title={trans("Related User")}
					item={selectedUser?.name}
				/>*/}
				{/**<ObjectSelectedRows
					title={trans("Assigned Driver")}
					item={
						driverData?.[0]?.name ? (
							<div className="hover-undreline cursor" onClick={() => onClick()}>
								<img
									src={`${process.env.PUBLIC_URL}/assets/Edit.svg`}
									alt="Edit"
									className="close-24"
								/>
								{driverData?.[0]?.name}
							</div>
						) : (
							<a className="text-primary cursor" onClick={() => onClick()}>
								{trans("Assign Driver")}
							</a>
						)
					}
				/>**/}
			</div>
			{/**{driverPopup && (
				<AssignDriverPopup
					title={trans("Assign Driver")}
					setDriverPopup={setDriverPopup}
					setIsControlsPopup={setIsControlsPopup}
					driverData={driverData}
					device={device}
				/>
			)}**/}
		</>
	);
}
